export default {
  data: () => ({
    local: localStorage,
  }),
  computed: {
    storage() {
      return {
        save: this.saveLocalItem,
        get: this.getLocalItem,
      };
    },
  },
  methods: {
    saveLocalItem(key, item) {
      this.local.setItem(
        key,
        JSON.stringify(item),
      );
    },
    getLocalItem(key) {
      const item = this.local.getItem(key);

      if (item) {
        try {
          const json = JSON.parse(item);
          return json;
        } catch (err) {
          return item;
        }
      }
      return item;
    },
  },
};
